import _ from 'lodash';
import gbvar from '../globalvariables';
import store from '../store/store';
const permissionsList = gbvar.permissionsList;
const navitems = {
        _name: "CSidebarNav",
        _children: [
            {
                _name: "CSidebarNavItem",
                name: "Dashboard",
                to: "/dashboard",
                icon: "cil-speedometer",
            },
            {
                _name: 'CSidebarNavTitle',
                _children: ['Access Control'],
                permission_name: permissionsList.manage_roles
            },
            {
                _name: "CSidebarNavItem",
                name: 'Roles',
                to: '/roles',
                icon: 'cil-star',
                permission_name: permissionsList.manage_roles
            },
            {
                _name: "CSidebarNavItem",
                name: 'Users',
                to: '/users',
                icon: 'cil-user',
                permission_name: permissionsList.manage_roles
            },
            {
                _name: 'CSidebarNavTitle',
                _children: ['Content Management'],
                //permission_name: permissionsList.tournament

            },
            {
                _name: "CSidebarNavItem",
                name: "Categories",
                to: "/categories",
                icon: "cil-drop",
                permission_name: permissionsList.category
               // permission_name: permissionsList.tournament
            },
            {
                _name: "CSidebarNavItem",
                name: "Topics",
                to: "/topics",
                icon: "cil-puzzle",
                permission_name: permissionsList.topic,
                //permission_name: permissionsList.tournament
            },
            {
                _name: "CSidebarNavItem",
                name: "Questions",
                to: "/questions",
                icon: "cil-calculator",
                 permission_name: permissionsList.question
                //permission_name: permissionsList.tournament
            },
            {
                _name: "CSidebarNavItem",
                name: "Reported Questions",
                to: "/reported-questions",
                icon: "cil-cloud-download",
                permission_name: permissionsList.question,
                //permission_name: permissionsList.tournament
            },
            {
                _name: "CSidebarNavItem",
                name: "Tournaments",
                to: "/tournaments",
                icon: "cil-chart-pie",
                permission_name: permissionsList.tournament
            },
            //TODO: Will be implemented of needed
            // {
            //     _name: "CSidebarNavItem",
            //     name: "Challenge Room",
            //     to: "/challenge-room",
            //     icon: "cil-chart-pie",
            //     //permission_name: permissionsList
            // },
            {
                _name: "CSidebarNavItem",
                name: "Bkash Promotion",
                to: "/bkash-promotion",
                icon: "cil-chart-pie",
                permission_name: permissionsList.tournament
            },

            {
                _name: "CSidebarNavItem",
                name: "Bkash Banner",
                to: "/bkash-promotions/banner",
                icon: "cil-chart-pie",
                permission_name: permissionsList.tournament
            },
            
            {
                _name: 'CSidebarNavTitle',
                _children: ['Marketing'],
                permission_name: permissionsList.tournament
            },
            {
                _name: "CSidebarNavItem",
                name: "Leaderboard",
                to: "/leaderboard",
                icon: "cil-grid",
                permission_name: permissionsList.tournament
            },
            {
                _name: "CSidebarNavItem",
                name: "LeaderBoardManipulation",
                to: "/leaderboardManipulation",
                icon: "cil-grid",
                permission_name: permissionsList.tournament
            },
            {
                _name: "CSidebarNavItem",
                name: "Recharges",
                to: "/recharges",
                icon: "cil-dollar",
                permission_name: permissionsList.tournament
            },
            {
                _name: "CSidebarNavItem",
                name: "Subscription Gratification",
                to: "/gratification",
                icon: "cil-dollar",
                permission_name: permissionsList.tournament
            },
            {
                _name: "CSidebarNavItem",
                name: "Daily Tasks",
                to: "/daily-tasks",
                icon: "cil-calendar",
                permission_name: permissionsList.tournament
            },
            {
                _name: "CSidebarNavItem",
                name: "Promotions",
                to: "/promotions",
                icon: "cil-bell",
                permission_name: permissionsList.tournament
            },
            {
                _name: "CSidebarNavItem",
                name: "PopUp Banner",
                to: "/promotions/pop-up",
                icon: "cil-envelope-open",
                permission_name: permissionsList.tournament
            },
            {
                _name: 'CSidebarNavTitle',
                _children: ['Reports'],
                permission_name: permissionsList.manage_roles
            },
            {
                _name: "CSidebarNavItem",
                name: "Reports",
                to: "/reports",
                icon: "cil-grid",
                permission_name: permissionsList.manage_roles
                // permission_name: permissionsList.dash_board
            },
            {
                _name: "CSidebarNavItem",
                name: "Revenue Report",
                to: "/reports/revenue",
                icon: "cil-grid",
                permission_name: permissionsList.manage_roles
                // permission_name: permissionsList.dash_board
            },
            {
                _name: "CSidebarNavItem",
                name: "User Payment History",
                to: "/bkash/user-payment-history",
                icon: "cil-grid",
                permission_name: permissionsList.manage_roles
                // permission_name: permissionsList.dash_board
            },
            {
                _name: "CSidebarNavItem",
                name: "Block User",
                to: "/block/user",
                icon: "cil-grid",
                permission_name: permissionsList.manage_roles

            },
            {
                _name: "CSidebarNavItem",
                name: "User History",
                to: "/user/history",
                icon: "cil-grid",
                permission_name: permissionsList.manage_roles

            },
            {
                _name: "CSidebarNavItem",
                name: "Campaign History",
                to: "/campaign/history",
                icon: "cil-grid",
                permission_name: permissionsList.manage_roles

            },
            {
                _name: 'CSidebarNavTitle',
                _children: ['Campaign Data'],
                permission_name: permissionsList.manage_roles
            },
            {
                _name: "CSidebarNavItem",
                name: "Campaign Data",
                to: "/campaign-data",
                icon: "cil-list",
                permission_name: permissionsList.manage_roles
            },


          /*
            {
                _name: "CSidebarNavItem",
                name: "Favorites",
                to: "/favorites",
            },
            {
                _name: "CSidebarNavItem",
                name: "Store",
                to: "/store",
            },
            {
                _name: "CSidebarNavItem",
                name: "Ranking",
                to: "/ranking",
            },*/
            // {
            //     _name: "CSidebarNavTitle",
            //     _children: ["Theme"],
            // },
            // {
            //     _name: "CSidebarNavItem",
            //     name: "Colors",
            //     to: "/theme/colors",
            //     icon: "cil-drop",
            // },
            // {
            //     _name: "CSidebarNavItem",
            //     name: "Typography",
            //     to: "/theme/typography",
            //     icon: "cil-pencil",
            // },
            // {
            //     _name: "CSidebarNavTitle",
            //     _children: ["Components"],
            // },
            // {
            //     _name: "CSidebarNavDropdown",
            //     name: "Base",
            //     route: "/base",
            //     icon: "cil-puzzle",
            //     items: [
            //         {
            //             name: "Breadcrumbs",
            //             to: "/base/breadcrumbs",
            //         },
            //         {
            //             name: "Cards",
            //             to: "/base/cards",
            //         },
            //         {
            //             name: "Carousels",
            //             to: "/base/carousels",
            //         },
            //         {
            //             name: "Collapses",
            //             to: "/base/collapses",
            //         },
            //         {
            //             name: "Forms",
            //             to: "/base/forms",
            //         },
            //         {
            //             name: "Jumbotrons",
            //             to: "/base/jumbotrons",
            //         },
            //         {
            //             name: "List Groups",
            //             to: "/base/list-groups",
            //         },
            //         {
            //             name: "Navs",
            //             to: "/base/navs",
            //         },
            //         {
            //             name: "Navbars",
            //             to: "/base/navbars",
            //         },
            //         {
            //             name: "Paginations",
            //             to: "/base/paginations",
            //         },
            //         {
            //             name: "Popovers",
            //             to: "/base/popovers",
            //         },
            //         {
            //             name: "Progress Bars",
            //             to: "/base/progress-bars",
            //         },
            //         {
            //             name: "Switches",
            //             to: "/base/switches",
            //         },
            //         {
            //             name: "Tables",
            //             to: "/base/tables",
            //         },
            //         {
            //             name: "Tabs",
            //             to: "/base/tabs",
            //         },
            //         {
            //             name: "Tooltips",
            //             to: "/base/tooltips",
            //         },
            //     ],
            // },
            // {
            //     _name: "CSidebarNavDropdown",
            //     name: "Buttons",
            //     route: "/buttons",
            //     icon: "cil-cursor",
            //     items: [
            //         {
            //             name: "Buttons",
            //             to: "/buttons/standard-buttons",
            //         },
            //         {
            //             name: "Button Dropdowns",
            //             to: "/buttons/dropdowns",
            //         },
            //         {
            //             name: "Button Groups",
            //             to: "/buttons/button-groups",
            //         },
            //         {
            //             name: "Brand Buttons",
            //             to: "/buttons/brand-buttons",
            //         },
            //     ],
            // },
            // {
            //     _name: "CSidebarNavItem",
            //     name: "Charts",
            //     to: "/charts",
            //     icon: "cil-chart-pie",
            // },
            // {
            //     _name: "CSidebarNavDropdown",
            //     name: "Icons",
            //     route: "/icons",
            //     icon: "cil-star",
            //     items: [
            //         {
            //             name: "CoreUI Icons",
            //             to: "/icons/coreui-icons",
            //             badge: {
            //                 color: "info",
            //                 text: "NEW",
            //             },
            //         },
            //         {
            //             name: "Brands",
            //             to: "/icons/brands",
            //         },
            //         {
            //             name: "Flags",
            //             to: "/icons/flags",
            //         },
            //     ],
            // },
            // {
            //     _name: "CSidebarNavDropdown",
            //     name: "Notifications",
            //     route: "/notifications",
            //     icon: "cil-bell",
            //     items: [
            //         {
            //             name: "Alerts",
            //             to: "/notifications/alerts",
            //         },
            //         {
            //             name: "Badges",
            //             to: "/notifications/badges",
            //         },
            //         {
            //             name: "Modals",
            //             to: "/notifications/modals",
            //         },
            //     ],
            // },
            // {
            //     _name: "CSidebarNavItem",
            //     name: "Widgets",
            //     to: "/widgets",
            //     icon: "cil-calculator",
            //     badge: {
            //         color: "primary",
            //         text: "NEW",
            //         shape: "pill",
            //     },
            // },
            // {
            //     _name: "CSidebarNavDivider",
            //     _class: "m-2",
            // },
            // {
            //     _name: "CSidebarNavTitle",
            //     _children: ["Extras"],
            // },
            // {
            //     _name: "CSidebarNavDropdown",
            //     name: "Pages",
            //     route: "/pages",
            //     icon: "cil-star",
            //     items: [
            //         {
            //             name: "Login",
            //             to: "/pages/login",
            //         },
            //         {
            //             name: "Register",
            //             to: "/pages/register",
            //         },
            //         {
            //             name: "Error 404",
            //             to: "/pages/404",
            //         },
            //         {
            //             name: "Error 500",
            //             to: "/pages/500",
            //         },
            //     ],
            // },
            // {
            //     _name: "CSidebarNavItem",
            //     name: "Download CoreUI",
            //     href: "http://coreui.io/vue/",
            //     icon: { name: "cil-cloud-download", class: "text-white" },
            //     _class: "bg-success text-white",
            //     target: "_blank",
            // },
            // {
            //     _name: "CSidebarNavItem",
            //     name: "Try CoreUI PRO",
            //     href: "http://coreui.io/pro/vue/",
            //     icon: { name: "cil-layers", class: "text-white" },
            //     _class: "bg-danger text-white",
            //     target: "_blank",
            // },
        ]
};
const navItemsToShow = navitems ;
navItemsToShow._children = _.filter(navItemsToShow._children, item => {
    return filterByPermissions(item);
});

function filterByPermissions(item) {
    if (Object.prototype.hasOwnProperty.call(item, 'permission_name')) {
        return store.getters['auth/hasPermission'](item.permission_name) ? item : null
    }
    return item;
}
export default [navItemsToShow];
